import { useTheme, VisitsResponse } from '@springbig/shared';
import dayjs from 'dayjs';
import { Box, VStack, HStack, Divider } from 'native-base';
import React from 'react';
import { Caption } from '~/shared/Typography';
import { Panel } from '~/shared/Theme';

const AccountHistoryPurchaseCard = ({ visit }: { visit: VisitsResponse }) => {

    const {
        primary,
    } = useTheme();

    return (
        <Panel mb={4} space={4}>
            <VStack
                alignItems={'center'}
                space={4}
            >
                <Caption
                    fontWeight={'bold'}
                    text='history.item_ordered'
                />
                <Caption>
                    { dayjs(visit.transaction_date).format('MM/DD/YYYY h:mm a') }
                </Caption>
                <Divider
                    bg={primary}
                    mt={2}
                />
            </VStack>
            {
                visit.visit_details && visit.visit_details.length > 0 && visit.visit_details.map((detail, i) => {

                    return (
                        <HStack
                            key={`${detail.id}-${i}`}
                            space={2}
                            w={'100%'}
                            alignItems={'center'}
                            justifyContent={'space-between'}
                        >
                            <Box>
                                <Caption
                                    fontWeight={'bold'}
                                    text='history.category'
                                />
                                <Caption>
                                    { detail.category }
                                </Caption>
                            </Box>
                            { detail.brand &&
                                <Box>
                                    <Caption
                                        fontWeight={'bold'}
                                        text='history.brand'
                                    />
                                    <Caption>
                                        { detail.brand }
                                    </Caption>
                                </Box>
                            }
                            <Box>
                                <Caption
                                    fontWeight={'bold'}
                                    text='history.product_name'
                                />
                                <Caption>
                                    { detail.name }
                                </Caption>
                            </Box>
                            <Divider
                                bg={primary}
                            />
                        </HStack>
                    );
                })
            }
            <HStack
                alignItems={'center'}
                justifyContent={'space-between'}
            >
                <Caption text='history.transaction_total' />
                <Caption>
                    ${ visit.transaction_total?.toFixed(2) }
                </Caption>
            </HStack>
        </Panel>
    );
};

export default AccountHistoryPurchaseCard;
